// src/menu-items/statistics.ts
import { Phone, PhonePlus, PhonePlusSolid, PhoneOutcome, PhoneMinus, PathArrow } from 'iconoir-react';


const numbers = {
  id: 'numbers-group',
  title: 'Numbers',
  type: 'group',
  children: [
    {
      id: 'numbers-search',
      title: 'Numbers',
      type: 'item',
      url: '/numbers/search',
      icon: Phone,
      breadcrumbs: true
    },
    {
      id: 'numbers-add',
      title: 'Add Numbers Admin',
      type: 'item',
      url: '/numbers/add',
      icon: PhonePlusSolid,
      breadcrumbs: true
    },
    {
      id: 'numbers-add-unused',
      title: 'Add Unused Numbers',
      type: 'item',
      url: '/numbers/add-unused',
      icon: PhonePlus,
      breadcrumbs: true
    },
    {
      id: 'numbers-move',
      title: 'Move Numbers',
      type: 'item',
      url: '/numbers/move',
      icon: PhoneOutcome,
      breadcrumbs: true
    },
    {
      id: 'numbers-delete',
      title: 'Delete Numbers',
      type: 'item',
      url: '/numbers/delete',
      icon: PhoneMinus,
      breadcrumbs: true
    },
    {
      id: 'reversed-screening-add',
      title: 'Reversed Screening',
      type: 'item',
      url: '/reversed-screening/add',
      icon: PathArrow,
      breadcrumbs: true
    }
  ]
};

export default numbers;
